'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIFilterBar from 'UIComponents/nav/UIFilterBar';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
const StyledFilterBar = styled(UIFilterBar).withConfig({
  displayName: "MobileFilterBar__StyledFilterBar",
  componentId: "sc-1wuwlcw-0"
})(["&&{padding-right:0 !important;}::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;"]);
const StyledMiddleSlot = styled(UIScrollContainer).withConfig({
  displayName: "MobileFilterBar__StyledMiddleSlot",
  componentId: "sc-1wuwlcw-1"
})(["overflow:scroll;width:100%;.middleSlot{display:flex;> div{padding-right:10px;}}"]);
StyledFilterBar.displayName = 'StyledFilterBar';

const MobileFilterBar = (_ref) => {
  let {
    children,
    className,
    startSlot,
    middleSlot
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "className", "startSlot", "middleSlot"]);

  useEffect(() => {
    if (children && startSlot) {
      console.warn('MobileFilterBar: children and startSlot cannot both be passed. Defaulting to startSlot');
    }
  }, [children, startSlot]);
  return /*#__PURE__*/_jsx(StyledFilterBar, Object.assign({}, props, {
    className: className,
    startSlot: startSlot,
    Middle: StyledMiddleSlot,
    middleSlot: /*#__PURE__*/_jsx("div", {
      className: "middleSlot",
      children: middleSlot
    }),
    responsive: false
  }));
};

MobileFilterBar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  startSlot: UIFilterBar.propTypes.startSlot,
  middleSlot: UIFilterBar.propTypes.middleSlot
};
export default MobileFilterBar;